import { render, staticRenderFns } from "./SettingsAppointmentTypesPage.vue?vue&type=template&id=6bea6a05"
import script from "./SettingsAppointmentTypesPage.vue?vue&type=script&lang=ts"
export * from "./SettingsAppointmentTypesPage.vue?vue&type=script&lang=ts"
import style0 from "./SettingsAppointmentTypesPage.vue?vue&type=style&index=0&id=6bea6a05&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports